import { RouteAnimationShared } from './../../../utils/route-animation-shared';
import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { GenerateShared } from '../../general/shared/generate-shared';
import { DietTypeService } from 'src/app/data/repository/generate-repository/diet-type.service';
import { ActivityLevelService } from 'src/app/data/repository/generate-repository/activity-level.service';
import { SubmitButtonShared } from '../../general/shared/submit-button-shared';
import { Subscription } from 'rxjs';
import { GenerateService } from 'src/app/data/repository/generate-repository/generate.service';
import * as moment from 'jalali-moment';
import { HatedFoodService } from 'src/app/data/repository/generate-repository/hated-food.service';
import { DiseaseService } from 'src/app/data/repository/generate-repository/disease.service';
import { PopupInputModel } from '../../general/popup/popup.component';
import { PopupShared } from '../../general/shared/popup-shared';
import { DifficultyService } from 'src/app/data/repository/generate-repository/difficulty.service';
import { SnackBarService } from 'src/app/data/repository/utils-repository/snack-bar.service';
import { Router } from '@angular/router';
import { mainUrl } from 'src/app/global-variables';
import { ShopService } from 'src/app/data/repository/shop-repository/shop.service';
import { CalendarShared } from '../../general/shared/calendar-shared';
import { WeightLogService } from 'src/app/data/repository/plan-repository/weight-log.service';
import { DateHelper } from 'src/app/utils/date-helper';
import { Weightlog } from 'src/app/core/model/api-response/weight-log-response-model';
import { DiaryAnalyticsService } from 'src/app/data/repository/analytics-repository/diary-analytics.service';
import { GenerateDataService } from 'src/app/data/repository/generate-repository/generate-data.service';
import { GenerateModel } from 'src/app/core/model/object/generate-model';
import { WebengageService } from 'src/app/data/repository/analytics-repository/webengage.service';

@Component({
  selector: 'app-generate-overview',
  templateUrl: './generate-overview.component.html',
  styleUrls: ['./generate-overview.component.scss'],
})
export class GenerateOverviewComponent implements OnInit, OnDestroy {
  buttonTitle = 'دریافت برنامه غذایی';
  showDetail = false;
  selectedDetail = -1;
  componentIds = [];
  showPopup = false;
  popupInputModel: PopupInputModel;
  weightLog: Weightlog;
  titles = [
    'نوع برنامه غذایی',
    'هدف برنامه غذایی',
    'وزن شروع',
    'سطح فعالیت',
    'گیاهخواری',
    'بیماری',
    'مواد غذایی حساسیت‌زا',
    'درجه سختی',
    'تاریخ شروع',
    'تاریخ شروع بارداری',
    'تاریخ شروع شیردهی',
    'روز فستینگ',
  ];
  values = ['', '', '', '', '', '', '', '', '', '', '', ''];

  showLoading = false;

  subscription1: Subscription;
  subscription2: Subscription;
  subscription3: Subscription;
  subscription4: Subscription;

  constructor(
    public generateShared: GenerateShared,
    private generateService: GenerateService,
    private dietTypeService: DietTypeService,
    private activityLevelService: ActivityLevelService,
    private diseaseService: DiseaseService,
    private hatedFoodService: HatedFoodService,
    private submitButtonShared: SubmitButtonShared,
    private popupShared: PopupShared,
    private difficultyService: DifficultyService,
    private snackBarService: SnackBarService,
    private router: Router,
    private shopService: ShopService,
    private calendarShared: CalendarShared,
    private weightLogService: WeightLogService,
    private dateHelper: DateHelper,
    private diaryAnalytics: DiaryAnalyticsService,
    private generateDataService: GenerateDataService,
    private routeAnimationShared: RouteAnimationShared,
    private webengage: WebengageService
  ) {
    this.generateDataService
      .getGenerate()
      .then((res) => {
        if (res.goal || res.dietType) {
          this.generateShared.selectedDietType = res.dietType;
          this.generateShared.weight = res.weight;
          this.generateShared.startDay = res.startDay;
          this.generateShared.startDays = res.startDays;
          this.generateShared.goal = res.goal;
          this.generateShared.setCalories(res.calories ? res.calories : []);
          this.generateShared.difficulty = res.difficulty;
          this.generateShared.calorie = res.calorie;
          this.generateShared.activityLevel = res.activityLevel;
          this.generateShared.specialTypeStartDate = new Date(
            res.specialTypeStartDate ? res.specialTypeStartDate : 0
          );
          this.generateShared.isVegeterian = res.isVegeterian;
          this.generateShared.setDiseases(res.diseases ? res.diseases : []);
          this.generateShared.setHatedFoods(
            res.hatedfoods ? res.hatedfoods : []
          );
          this.generateShared.setFastingDays(
            res.fastingDays ? res.fastingDays : []
          );
        }
      })
      .then(() => {
        // console.log(this.generateShared.goal)
        console.log(this.generateShared.weight);
        // console.log(this.generateShared.activityLevel)
        // console.log(this.generateShared.isVegeterian)
        // console.log(this.generateShared.getDiseases())
        // console.log(this.generateShared.getHatedFoods())
        // console.log(this.generateShared.difficulty)
        // console.log(this.generateShared.startDay)
        // console.log(this.generateShared.selectedDietType);
        // console.log(this.generateShared.specialTypeStartDate)
        // console.log(this.generateShared.getFastingDays());

        if (!this.generateShared.selectedDietType) {
          this.close(false);
        }

        this.goalChanged();
        this.prepareValues();
        this.submitButtonShared.activateNextButton(true);
      });

    this.subscription1 = this.generateShared.closeOverviewDetailObs$.subscribe(
      (close) => {
        if (close) {
          this.closeOverviewDetail();
        }
      }
    );
    this.subscription2 =
      this.generateShared.closeOverviewDetailAndChangeDifficultyObs$.subscribe(
        (close) => {
          if (close) {
            if (this.generateShared.goal) {
              if (
                this.generateShared.selectedDietType &&
                this.generateShared.selectedDietType.fasting
              ) {
                this.generateShared.setFastingDays([]);
              }
              // console.log('preg', this.generateShared.specialTypeStartDate)
              this.goalChanged();
              this.generateShared.difficulty = -1;
              if (
                (this.generateShared.goal !== 'breastfeeding' &&
                  this.generateShared.goal !== 'pregnancy') ||
                (this.generateShared.specialTypeStartDate &&
                  this.generateShared.specialTypeStartDate.getTime() !== 0)
              ) {
                this.showLoading = true;
                this.generateService
                  .calculate(
                    this.generateShared.weight,
                    this.generateShared.goal,
                    this.activityLevelService.getActivityLevelEngNameById(
                      this.generateShared.activityLevel
                    ),
                    this.generateShared.goal === 'pregnancy'
                      ? this.generateShared.specialTypeStartDate.getTime()
                      : null,
                    this.generateShared.goal === 'breastfeeding'
                      ? this.generateShared.specialTypeStartDate.getTime()
                      : null
                  )
                  .then((res) => {
                    if (res.isSuccess()) {
                      this.closeOverviewDetail();
                    } else {
                      if (res.getData() && res.getData().getMessage()) {
                        this.snackBarService.showSnackBar(
                          res.getData().getMessage()
                        );
                      } else {
                        this.snackBarService.showSnackBar(
                          'خطا در برقراری ارتباط با سرور!'
                        );
                      }
                    }
                    this.showLoading = false;
                  });
              } else {
                this.closeOverviewDetail();
              }
            } else {
              this.goalChanged();
              this.closeOverviewDetail();
            }
          }
        }
      );
    this.subscription3 = this.submitButtonShared.nextButtonClickObs$.subscribe(
      (clicked) => {
        if (clicked && this.selectedDetail === -1) {
          if (this.generateInputsAreOk()) {
            // console.log('generaate')
            this.showLoading = true;
            this.shopService.getPlanSubscription(true).then((res) => {
              if (res.isSuccess()) {
                if (res.getData().getPlanSubscription().remainingDays > 0) {
                  this.generate();
                } else {
                  this.shopService.goToShopPage('generate');
                }
              } else {
                this.showLoading = false;
                this.snackBarService.showSnackBar(
                  'خطا در برقراری ارتباط با سرور!'
                );
              }
            });
          }
        }
      }
    );
    this.subscription4 = this.popupShared.closePopupObs$.subscribe((close) => {
      if (close) {
        this.showPopup = false;
      }
    });
  }

  ngOnInit() {
    this.generateService.isDetail = true;
    setTimeout(() => {
      this.submitButtonShared.animateUpButton();
    }, 10);
    this.showLoading = true;
    this.weightLogService.getCurrentWeight().then((res) => {
      if (res.isSuccess()) {
        this.weightLog = res.getData().getWeightLog();
      } else {
        this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
      }
      this.showLoading = false;
    });
  }

  @HostListener('window:beforeunload')
  ngOnDestroy(): void {
    this.generateService.isDetail = false;
    this.subscription1.unsubscribe();
    this.subscription2.unsubscribe();
    this.subscription3.unsubscribe();
    this.subscription4.unsubscribe();
  }

  close(updateGenerateModel: boolean) {
    if (updateGenerateModel) {
      const generate = new GenerateModel(
        this.generateShared.selectedDietType,
        this.generateShared.weight,
        this.generateShared.startDay,
        this.generateShared.startDays,
        this.generateShared.goal,
        this.generateShared.getCalories(),
        this.generateShared.difficulty,
        this.generateShared.calorie,
        this.generateShared.activityLevel,
        this.generateShared.specialTypeStartDate
          ? this.generateShared.specialTypeStartDate.getTime()
          : 0,
        this.generateShared.isVegeterian,
        this.generateShared.getDiseases(),
        this.generateShared.getHatedFoods(),
        this.generateShared.getFastingDays()
      );
      this.generateDataService.saveGenerate(generate);
    }
    setTimeout(() => {
      this.routeAnimationShared.showRouteAnimation();
      this.router.navigate([mainUrl]);
      this.generateService.isDetail = false;
    }, 100);
  }

  generate() {
    if (this.generateShared.goal) {
      this.generateService
        .generate(
          this.generateShared.selectedDietType.id,
          this.generateShared.weight,
          this.generateShared.startDay,
          this.generateShared.goal === 'weightLoss' ||
            this.generateShared.goal === 'weightGain'
            ? this.generateShared.getCalories()[this.generateShared.difficulty]
                .amount
            : parseInt(this.generateShared.calorie),
          this.generateShared.goal,
          this.activityLevelService.getActivityLevelEngNameById(
            this.generateShared.activityLevel
          ),
          this.generateShared.goal === 'weightLoss' ||
            this.generateShared.goal === 'weightGain'
            ? this.generateShared.getCalories()[this.generateShared.difficulty]
                .difficulty
            : 'none',
          this.generateShared.goal === 'pregnancy'
            ? this.generateShared.specialTypeStartDate.getTime()
            : null,
          this.generateShared.goal === 'breastfeeding'
            ? this.generateShared.specialTypeStartDate.getTime()
            : null,
          this.generateShared.isVegeterian ? ['5e5e3f0915d60303417e90d9'] : [],
          this.diseaseService.getDiseasesIds(this.generateShared.getDiseases()),
          this.hatedFoodService.getHatedFoodsIds(
            this.generateShared.getHatedFoods()
          ),
          this.generateShared.selectedDietType.type === 'daily'
            ? this.generateService.getFastingDaysArray(
                this.generateShared.getFastingDays()
              )
            : []
        )
        .then((res) => {
          if (res.isSuccess()) {
            if (this.generateShared.isCanceling) {
              this.diaryAnalytics.analyticDiaryDietCanceled(
                this.generateShared.cancelDay
              );
            }
            let today = new Date();
            today = new Date(today.setHours(0, 0, 0, 1));
            if (
              this.dateHelper.isSameDay(today, new Date(this.weightLog.date)) &&
              this.weightLog._id !== '-'
            ) {
              this.weightLogService
                .updateWeight(this.generateShared.weight, this.weightLog._id)
                .then((result) => {
                  // alert(JSON.stringify({ line: 338, result }));
                  // alert(JSON.stringify({ line: 339, res }));

                  if (result.isSuccess()) {
                    this.diaryAnalytics.analyticDiaryGetDietCompleted(
                      this.generateShared.goal,
                      this.generateShared.isVegeterian
                        ? this.generateShared.isVegeterian
                        : false,
                      this.generateShared.goal === 'weightLoss' ||
                        this.generateShared.goal === 'weightGain'
                        ? this.generateShared.getCalories()[
                            this.generateShared.difficulty
                          ].difficulty
                        : 'none',
                      this.activityLevelService.getActivityLevelEngNameById(
                        this.generateShared.activityLevel
                      ),
                      this.generateShared.getHatedFoods().length === 0
                        ? false
                        : true,
                      this.generateShared.getDiseases().length === 0
                        ? false
                        : true,
                      this.generateShared.startDay
                    );
                    this.webengage.dieGenerated(
                      this.generateShared.selectedDietType.name,
                      this.generateShared.goal
                    );
                    this.calendarShared.selectedDate = new Date(
                      new Date().setHours(0, 0, 1, 0)
                    );
                    this.generateShared.goal = null;
                    this.generateShared.selectedDietType = null;
                    this.generateDataService.removeGenerate();
                    this.routeAnimationShared.showRouteAnimation();
                    this.router.navigate(['/main/plan']);
                  } else {
                    this.snackBarService.showSnackBar(
                      'خطا در برقراری ارتباط با سرور!'
                    );
                  }
                  this.showLoading = false;
                });
            } else {
              this.weightLogService
                .addWeight(today.getTime(), this.generateShared.weight)
                .then((result) => {
                  // alert(JSON.stringify({ line: 383, result }));
                  // alert(JSON.stringify({ line: 384, res }));

                  if (result.isSuccess()) {
                    this.webengage.dieGenerated(
                      this.generateShared.selectedDietType.name,
                      this.generateShared.goal
                    );
                    this.diaryAnalytics.analyticDiaryGetDietCompleted(
                      this.generateShared.goal,
                      this.generateShared.isVegeterian
                        ? this.generateShared.isVegeterian
                        : false,
                      this.generateShared.goal === 'weightLoss' ||
                        this.generateShared.goal === 'weightGain'
                        ? this.generateShared.getCalories()[
                            this.generateShared.difficulty
                          ].difficulty
                        : 'none',
                      this.activityLevelService.getActivityLevelEngNameById(
                        this.generateShared.activityLevel
                      ),
                      this.generateShared.getHatedFoods().length === 0
                        ? false
                        : true,
                      this.generateShared.getDiseases().length === 0
                        ? false
                        : true,
                      this.generateShared.startDay
                    );
                    this.calendarShared.selectedDate = new Date(
                      new Date().setHours(0, 0, 1, 0)
                    );
                    this.generateShared.goal = null;
                    this.generateShared.selectedDietType = null;
                    this.generateDataService.removeGenerate();
                    this.routeAnimationShared.showRouteAnimation();
                    this.router.navigate(['/main/plan']);
                  } else {
                    this.snackBarService.showSnackBar(
                      'خطا در برقراری ارتباط با سرور!'
                    );
                  }
                  this.showLoading = false;
                });
            }
          } else {
            // alert(JSON.stringify({ line: 426, e: 'error' }));
            // alert(JSON.stringify({ line: 427, e: 'erorr' }));
            this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
            this.showLoading = false;
          }
        });
    } else if (this.generateShared.selectedDietType) {
      this.generateService
        .generatePredefined(
          this.generateShared.weight,
          this.generateShared.startDay,
          this.activityLevelService.getActivityLevelEngNameById(
            this.generateShared.activityLevel
          ),
          this.generateShared.selectedDietType.id
        )
        .then((res) => {
          // alert(JSON.stringify({ line: 443, e: res }));
          if (res.isSuccess()) {
            if (this.generateShared.isCanceling) {
              this.diaryAnalytics.analyticDiaryDietCanceled(
                this.generateShared.cancelDay
              );
            }
            let today = new Date();
            today = new Date(today.setHours(0, 0, 0, 1));
            if (
              this.dateHelper.isSameDay(today, new Date(this.weightLog.date)) &&
              this.weightLog._id !== '-'
            ) {
              this.weightLogService
                .updateWeight(this.generateShared.weight, this.weightLog._id)
                .then((result) => {
                  if (result.isSuccess()) {
                    // this.diaryAnalytics.analyticDiaryGetDietCompleted(
                    //   this.generateShared.goal,
                    //   this.generateShared.isVegeterian,
                    //   this.generateShared.goal === 'weightLoss' || this.generateShared.goal === 'weightGain' ?
                    //     this.generateShared.getCalories()[this.generateShared.difficulty].difficulty  : 'none',
                    //   this.activityLevelService.getActivityLevelEngNameById(this.generateShared.activityLevel),
                    //   this.generateShared.getHatedFoods().length === 0 ? false : true,
                    //   this.generateShared.getDiseases().length === 0 ? false : true,
                    //   this.generateShared.startDay
                    // );
                    this.calendarShared.selectedDate = new Date(
                      new Date().setHours(0, 0, 1, 0)
                    );
                    this.generateShared.goal = null;
                    this.generateShared.selectedDietType = null;
                    this.generateDataService.removeGenerate();
                    this.routeAnimationShared.showRouteAnimation();
                    this.router.navigate(['/main/plan']);
                    // alert(JSON.stringify({ line: 478, e: result }));
                  } else {
                    this.snackBarService.showSnackBar(
                      'خطا در برقراری ارتباط با سرور!'
                    );
                    // alert(JSON.stringify({ line: 484, e: 'error' }));
                  }
                  this.showLoading = false;
                });
            } else {
              this.weightLogService
                .addWeight(today.getTime(), this.generateShared.weight)
                .then((result) => {
                  if (result.isSuccess()) {
                    // this.diaryAnalytics.analyticDiaryGetDietCompleted(
                    //   this.generateShared.goal,
                    //   this.generateShared.isVegeterian,
                    //   this.generateShared.goal === 'weightLoss' || this.generateShared.goal === 'weightGain' ?
                    //     this.generateShared.getCalories()[this.generateShared.difficulty].difficulty  : 'none',
                    //   this.activityLevelService.getActivityLevelEngNameById(this.generateShared.activityLevel),
                    //   this.generateShared.getHatedFoods().length === 0 ? false : true,
                    //   this.generateShared.getDiseases().length === 0 ? false : true,
                    //   this.generateShared.startDay
                    // );
                    this.calendarShared.selectedDate = new Date(
                      new Date().setHours(0, 0, 1, 0)
                    );
                    this.generateShared.goal = null;
                    this.generateShared.selectedDietType = null;
                    this.generateDataService.removeGenerate();
                    this.routeAnimationShared.showRouteAnimation();
                    this.router.navigate(['/main/plan']);
                    // alert(JSON.stringify({ line: 512, e: result }));
                  } else {
                    // alert(JSON.stringify({ line: 516, e: 'error' }));

                    this.snackBarService.showSnackBar(
                      'خطا در برقراری ارتباط با سرور!'
                    );
                  }
                  this.showLoading = false;
                });
            }
          } else {
            // alert(JSON.stringify({ line: 517, e: res }));

            this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
            this.showLoading = false;
          }
        });
    }
  }

  openOverviewDetail(id: number) {
    this.selectedDetail = id;
    this.showDetail = true;
    this.submitButtonShared.animateDownButton();
    setTimeout(() => {
      this.animateUp();
      setTimeout(() => {
        if (
          id === 2 ||
          id === 3 ||
          id === 5 ||
          id === 6 ||
          id === 8 ||
          id === 9 ||
          id === 10
        ) {
          this.submitButtonShared.animateUpButton();
          this.submitButtonShared.activateNextButton(true);
          this.buttonTitle = 'ثبت';
        } else if (id === 11) {
          this.submitButtonShared.animateUpButton();
          this.buttonTitle = 'ثبت';
          if (
            this.generateShared.selectedDietType.fasting >
            this.generateShared.getFastingDays().length
          ) {
            this.submitButtonShared.activateNextButton(false);
          } else {
            this.submitButtonShared.activateNextButton(true);
          }
        }
      }, 300);
    }, 400);
  }

  closeOverviewDetail() {
    this.prepareValues();
    if (
      this.selectedDetail === 2 ||
      this.selectedDetail === 3 ||
      this.selectedDetail === 5 ||
      this.selectedDetail === 6 ||
      this.selectedDetail === 8 ||
      this.selectedDetail === 9 ||
      this.selectedDetail === 10 ||
      this.selectedDetail === 11
    ) {
      this.submitButtonShared.animateDownButton();
      setTimeout(() => {
        this.animateDown();
        setTimeout(() => {
          this.showDetail = false;
          this.selectedDetail = -1;
          this.submitButtonShared.animateUpButton();
          this.buttonTitle = 'دریافت برنامه غذایی';
        }, 300);
      }, 500);
    } else {
      setTimeout(() => {
        this.animateDown();
        setTimeout(() => {
          this.showDetail = false;
          this.selectedDetail = -1;
          this.submitButtonShared.animateUpButton();
        }, 300);
      }, 200);
    }
  }

  animateUp() {
    document.getElementById('overview-detail').style.top = '0';
  }

  animateDown() {
    document.getElementById('overview-detail').style.top = '100%';
  }

  prepareValues() {
    this.componentIds.forEach((id) => {
      switch (id) {
        case 0: {
          if (this.generateShared.selectedDietType.isPersonal) {
            this.values[0] = 'شخصی';
          } else {
            this.values[0] = this.generateShared.selectedDietType.name;
          }
          break;
        }
        case 1: {
          if (
            this.generateShared.goal === 'weightLoss' ||
            this.generateShared.goal === 'weightGain'
          ) {
            this.values[1] = this.dietTypeService.getDietTypeNameByEngName(
              this.generateShared.goal
            );
          } else {
            this.values[1] =
              this.dietTypeService.getDietTypeNameByEngName(
                this.generateShared.goal
              ) +
              ' (' +
              this.generateShared.calorie +
              ' کالری)';
          }
          break;
        }
        case 2: {
          this.values[2] = this.generateShared.weight + ' کیلوگرم';
          break;
        }
        case 3: {
          this.values[3] = this.activityLevelService.getActivityLevelNameById(
            this.generateShared.activityLevel
          );
          break;
        }
        case 4: {
          this.values[4] = this.generateShared.isVegeterian ? 'بله' : 'خیر';
          break;
        }
        case 5: {
          const diseases = this.generateShared.getDiseases();
          if (diseases.length === 0) {
            this.values[5] = 'ندارم';
          } else if (diseases.length === 1) {
            this.values[5] = diseases[0];
          } else {
            this.values[5] = diseases[0] + '،...';
          }
          break;
        }
        case 6: {
          const hatedfoods = this.generateShared.getHatedFoods();
          if (hatedfoods.length === 0) {
            this.values[6] = 'ندارم';
          } else if (hatedfoods.length === 1) {
            this.values[6] = hatedfoods[0];
          } else {
            this.values[6] = hatedfoods[0] + '،...';
          }
          break;
        }
        case 7: {
          const calories = this.generateShared.getCalories();
          const index = this.generateShared.difficulty;
          if (index !== -1) {
            this.values[7] =
              this.difficultyService.convertDifficultyToPersian(
                calories[index].difficulty
              ) +
              ' (' +
              calories[index].amount +
              ' کالری)';
          } else {
            this.values[7] = 'مشخص کنید';
          }
          break;
        }
        case 8: {
          const index = this.generateShared.startDay;
          const startDays = this.generateShared.startDays;
          this.values[8] = startDays[index];
          break;
        }
        case 9: {
          if (
            this.generateShared.specialTypeStartDate &&
            this.generateShared.specialTypeStartDate.getTime() !== 0
          ) {
            const date = this.generateShared.specialTypeStartDate;
            this.values[9] = moment(date).format('jYYYY/jMM/jDD');
          } else {
            this.values[9] = 'مشخص کنید';
          }
          break;
        }
        case 10: {
          if (
            this.generateShared.specialTypeStartDate &&
            this.generateShared.specialTypeStartDate.getTime() !== 0
          ) {
            const date = this.generateShared.specialTypeStartDate;
            this.values[10] = moment(date).format('jYYYY/jMM/jDD');
          } else {
            this.values[10] = 'مشخص کنید';
          }
          break;
        }
        case 11: {
          const fastingDays = this.generateShared.getFastingDays();
          if (fastingDays.length === 0) {
            this.values[11] = 'مشخص کنید';
          } else if (fastingDays.length === 1) {
            this.values[11] = fastingDays[0];
          } else if (fastingDays.length === 2) {
            this.values[11] = fastingDays[0] + '، ' + fastingDays[1];
          } else {
            this.values[11] = fastingDays[0] + '،...';
          }
          break;
        }
      }
    });
  }

  goalChanged() {
    if (!this.generateShared.goal) {
      this.componentIds = [0, 2, 3, 8];
    } else if (
      this.generateShared.selectedDietType &&
      this.generateShared.selectedDietType.type === 'daily'
    ) {
      switch (this.generateShared.goal) {
        case 'weightLoss': {
          // this.componentIds = [0, 1, 2, 3, 5, 6, 7];
          this.componentIds = [0, 1, 11, 2, 3, 4, 5, 6, 7, 8];
          break;
        }
        case 'weightFix': {
          // this.componentIds = [0, 1, 2, 3, 5, 7];
          this.componentIds = [0, 1, 11, 2, 3, 4, 5, 6, 8];
          break;
        }
      }
    } else {
      switch (this.generateShared.goal) {
        case 'weightLoss': {
          // this.componentIds = [0, 1, 2, 3, 5, 6, 7];
          this.componentIds = [0, 1, 2, 3, 4, 5, 6, 7, 8];
          break;
        }
        case 'weightGain': {
          // this.componentIds = [0, 1, 2, 3, 5, 6, 7];
          this.componentIds = [0, 1, 2, 3, 4, 5, 6, 7, 8];
          break;
        }
        case 'weightFix': {
          // this.componentIds = [0, 1, 2, 3, 5, 7];
          this.componentIds = [0, 1, 2, 3, 4, 5, 6, 8];
          break;
        }
        case 'pregnancy': {
          // this.componentIds = [0, 8, 1, 2, 3, 5, 7];
          this.componentIds = [0, 1, 9, 2, 3, 4, 5, 6, 8];
          break;
        }
        case 'breastfeeding': {
          // this.componentIds = [0, 9, 1, 2, 3, 5, 7];
          this.componentIds = [0, 1, 10, 2, 3, 4, 5, 6, 8];
          break;
        }
      }
    }
  }

  generateInputsAreOk() {
    if (this.generateShared.goal) {
      switch (this.generateShared.goal) {
        case 'weightLoss': {
          if (this.generateShared.difficulty === -1) {
            this.popupInputModel = new PopupInputModel(
              'درجه سختی',
              'درجه سختی خود را اول انتخاب کنید',
              'باشه'
            );
            this.showPopup = true;
            return false;
          } else if (
            this.generateShared.selectedDietType.type === 'daily' &&
            this.generateShared.selectedDietType.fasting >
              this.generateShared.getFastingDays().length
          ) {
            this.popupInputModel = new PopupInputModel(
              'روز فستینگ',
              'روز فستینگ خود را اول انتخاب کنید',
              'باشه'
            );
            this.showPopup = true;
            return false;
          } else {
            return true;
          }
        }
        case 'weightGain': {
          if (this.generateShared.difficulty === -1) {
            this.popupInputModel = new PopupInputModel(
              'درجه سختی',
              'درجه سختی خود را اول انتخاب کنید',
              'باشه'
            );
            this.showPopup = true;
            return false;
          } else {
            return true;
          }
        }
        case 'weightFix': {
          if (
            this.generateShared.selectedDietType.type === 'daily' &&
            this.generateShared.selectedDietType.fasting >
              this.generateShared.getFastingDays().length
          ) {
            this.popupInputModel = new PopupInputModel(
              'روز فستینگ',
              'روز فستینگ خود را اول انتخاب کنید',
              'باشه'
            );
            this.showPopup = true;
            return false;
          }
          return true;
        }
        case 'pregnancy': {
          if (
            !this.generateShared.specialTypeStartDate ||
            this.generateShared.specialTypeStartDate.getTime() === 0
          ) {
            this.popupInputModel = new PopupInputModel(
              'تاریخ شروع بارداری',
              'تاریخ شروع بارداری خود را اول انتخاب کنید',
              'باشه'
            );
            this.showPopup = true;
            return false;
          } else {
            return true;
          }
        }
        case 'breastfeeding': {
          if (
            !this.generateShared.specialTypeStartDate ||
            this.generateShared.specialTypeStartDate.getTime() === 0
          ) {
            this.popupInputModel = new PopupInputModel(
              'تاریخ شروع شیردهی',
              'تاریخ شروع شیردهی خود را اول انتخاب کنید',
              'باشه'
            );
            this.showPopup = true;
            return false;
          } else {
            return true;
          }
        }
      }
    } else {
      return true;
    }
  }
}
